(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  function open() { if (drawer) { drawer.hidden = false; document.body.style.overflow = 'hidden'; } }
  function close() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var qtyInput = document.querySelector('[data-qty-input]');
  function setQty(n) {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, n);
    document.querySelectorAll('.tier').forEach(function (t) {
      t.classList.toggle('is-on', Number(t.dataset.qty) === Number(qtyInput.value));
    });
  }
  document.querySelectorAll('.tier').forEach(function (t) {
    t.addEventListener('click', function () { setQty(Number(t.dataset.qty)); });
  });
  var minus = document.querySelector('[data-qty-minus]');
  var plus = document.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { setQty(Number(qtyInput.value) - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(Number(qtyInput.value) + 1); });

  // AJAX add to cart -> refresh drawer
  var form = document.getElementById('BuyForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }); })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
          var count = doc.querySelector('.cart-count');
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            if (count) el.textContent = count.textContent;
          });
          open();
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  }
  // Daily-resetting countdown
  (function () {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var resetHour = parseInt(el.getAttribute('data-reset-hour') || '0', 10);
    var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = new Date();
      var next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), resetHour, 0, 0, 0);
      if (next <= now) next.setDate(next.getDate() + 1);
      var d = Math.max(0, Math.floor((next - now) / 1000));
      h.textContent = pad(Math.floor(d / 3600));
      m.textContent = pad(Math.floor((d % 3600) / 60));
      s.textContent = pad(d % 60);
    }
    tick();
    setInterval(tick, 1000);
  })();

  // Mobile sticky bar -> submit the real form
  var mAdd = document.querySelector('[data-mbar-add]');
  if (mAdd) mAdd.addEventListener('click', function () {
    var f = document.getElementById('BuyForm');
    if (f) { f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    else { open(); }
  });
})();
